<template>
    <div class="uploader">
        <template v-if="!edit">
            <div class="image" v-show="previewSrc" :style="{ 'background-image': 'url(' + previewSrc + ')' }" @click="selectFile">
            </div>
            <input ref="uploader" style="opacity: 0 ; position: absolute; right: 0; left: 0; margin-left: 30%; margin-right: auto;" type="file" :id="name" :name="name" @change="inputChanged">
            <button type="button" v-show="! previewSrc" class="btn btn-xs btn-primary" @click="selectFile">
                <i  class="icon_camera"></i>
                <span class="label">{{ label }}</span>
            </button>
        </template>
        <template v-if="edit" class="uploader">
            <div class="image" v-show="previewSrc">
                <img :src="previewSrc">
                <button type="button" v-show="previewSrc" class="btn btn-xs btn-danger edit-btn" @click="selectFile"><i class="icon icon_edit"></i></button>
            </div>
            <input ref="uploader" style="opacity: 0 ; position: absolute; right: 0; left: 0; margin-left: 30%; margin-right: auto;" type="file" :id="name" :name="name" @change="inputChanged" required>
            <div v-if="edited" class="buttons-form">
                <button class="button is-primary hvr-shutter-out-vertical hvr-warning is-rounded pr40 pl40" @click="save">حفظ</button>
                <button class="button is-warning hvr-shutter-out-vertical hvr-primary has-text-white is-rounded pr40 pl40" @click="resetEdit">الغاء</button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'uploader',
        props: {
            name: '',
            file: '',
            label:'' ,
            edit :false,
            url:''
        },
        data: () => ({
            addedFile: null,
            removed: false,
            edited:false,
            type : 'featured'
        }),
        computed: {
            previewSrc() {
                if (! this.addedFile) {
                    return this.removed ? false : this.file;
                }

                return URL.createObjectURL(this.addedFile);
            }
        },
        methods: {
            inputChanged(event) {
                this.$emit('input', event.target.files);
                this.addedFile = event.target.files[0];
                this.removed = false;
                if(this.edit){
                    var filename = this.file.substring(this.file.lastIndexOf('/')+1);
                    if(this.addedFile){
                        if(filename == this.addedFile.name ){
                           this.edited = false
                        }
                        else{
                           this.edited = true
                        }
                    }
                    else{
                       this.edited = false
                    }
                }
                else {
                    this.save();
                }
            },
            selectFile() {
                this.$refs.uploader.click();
            },
            removeFile() {
                this.$refs.uploader.value = '';
                this.addedFile = null;
                this.removed = true;
            },
            resetEdit(){
                this.edited=false;
                this.addedFile = null
            },
            save(){
                let fd= new FormData();
                if (this.edit) {
                    this.type = 'cover';
                }
                fd.append('image', this.addedFile);
                fd.append('type', this.type);
                axios.post(this.url, fd)
                    .then(response => {
                        this.edited = false;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    };
</script>
<style>
.uploader{
    text-align: center;
    position: relative;
}
.uploader .btn.btn-xs.btn-primary {
    width: 100%;
    height: 150px;
    border-radius: 3px;
    min-width: 125px;
    padding: 0px;
}
.uploader .btn.btn-xs.btn-primary i{

    font-size: 110px;
}

.uploader .btn.btn-xs.btn-primary .label{
}
.uploader  img.img-responsive{
    color: #fff;
    width: 100%;
    height: 150px;
    border-radius: 50%;
    min-width: 125px;
    padding: 0px;
}
.uploader .image{
    position: relative;
    width: 100%;
    height: 150px;
    background-color: transparent;
    border-radius: 3px;
    min-width: 125px;
    padding: 0px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin: auto;

}
.uploader .btn.btn-xs.btn-danger{
    background-color: rgba(16, 16, 16, 0.34);
    position: absolute;
    top: 0px;
    right: 0;
    width: 100%;
    height: 150px;
    border-radius: 3px;
    font-size: 30px;
}
.buttons-form {
    position: absolute;
    bottom: 10px;
    right: 10px;
    z-index: 3;
}
</style>

